<ng-container *ngIf="itemTemplate">
    <div class="boxset-container" *ngFor="let boxset of mosaic.boxsets; let blockIndex = index"
         [attr.data-n-items]="boxset.number_of_items" [attr.data-type]="boxset?.type?.type ? boxset.type.type : null">

        <div class="boxset-item" *ngFor="let item of boxset.items; let i = index">

            <ng-template
                    *ngTemplateOutlet="itemTemplate; context: { data: item, index: i }"
            ></ng-template>

        </div>
    </div>
</ng-container>
